export default {
  state: {
    loggedIn: false,
    user: {
      id: null,
      email: null,
      first_name: null,
      last_name: null,
      role: null,
      token: null,
      created_at: null,
    }
  },
  getters: {
    fullName: (state) => {
      return state.user.first_name + " " + state.user.last_name
    },
    getUser: (state) =>{
      return state.user;
    },
  },
  mutations: {
    setUser (state, data){
      state.loggedIn = true;
      state.user = data;
      if (data.role.Int64){
          state.user.role = data.role.Int64;
      } else {
          state.user.role = data.role
      }
      
      console.log("setUser role: ", state.user.role, data)
    },
    logout (state){
      state.loggedIn = false
      state.user = { email: null, first_name: null, last_name: null, role: null, token: null, created_at: null }
    }
  },
  actions: {
    setUser ({commit}, data){
      commit('setUser', data)
    },
    logout ({commit}){
      commit('logout')
    }
  }
}